import { h, Component } from 'preact';

export class Canvas extends Component {
    componentDidMount() {
        this.draw();
    }

    componentDidUpdate() {
        this.draw();
    }

    draw() {
        if (this.el) {
            const context = this.el.getContext('2d');

            context.clearRect(0, 0, this.el.width, this.el.height);
            this.drawPaths(this.props.paths, context);
        }
    }

    drawPaths(paths, context) {
        paths.forEach(path => {
            context.strokeStyle = path.color || 'white';
            context.lineWidth = path.lineWidth;
            context.shadowOffsetX = path.shadowOffsetX;
            context.shadowOffsetY = path.shadowOffsetY;
            context.shadowBlur = path.shadowBlur;
            context.shadowColor = path.shadowColor;

            this.drawPoints(path.points, context);
        });
    }

    drawPoints(points, context) {
        const firstPoint = points[0];

        context.beginPath();
        context.moveTo(firstPoint.x, firstPoint.y);

        points.slice(1).forEach(point => {
            context.lineTo(point.x, point.y);
        });

        context.stroke();
    }

    render() {
        return <canvas ref={ el => this.el = el } width={ this.props.width } height={ this.props.height } style={ { width: '100%', height: '100%' } } { ...this.attrs }/>
    }

    get attrs() {
        return this.props.attrs || {};
    }
}